import { useState } from "react";
import { Modal, Input, Button, Upload, Typography, message } from "antd";
import { uploadFile, addItemDeitsCuisines } from "../useCategoryAPI"; // Import the above utility functions
import DefaultImage from "../../../Assets/images/Default-image.png";

const AddDietCusiniesModal = ({
  showAddModalForDietCusines,
  setShowAddModalForDietCusines,
  currentCategory,
  fetchDietaryPreferences,
  fetchCuisines,
}) => {
  const [newItem, setNewItem] = useState({ name: "", image: null });
  const [isLoading, setIsLoading] = useState(false);

  const handleUploadAndSave = async () => {
    if (!newItem.image || !newItem.name) {
      return message.error("Please provide both a name and an image.");
    }

    try {
      setIsLoading(true);
      //upload the image and get the id
      const coverPhotoId = await uploadFile(newItem.image);
      if (!coverPhotoId) {
        throw new Error("File upload failed.");
      }

      // Step 2: Add Item
      await addItemDeitsCuisines(currentCategory, newItem.name, coverPhotoId);
      message.success("Item added successfully!");

      setNewItem({ name: "", image: null });
      setShowAddModalForDietCusines(false);
      if (currentCategory === "Dietary Preference") {
        fetchDietaryPreferences();
      } else {
        fetchCuisines();
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "Failed to add item. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={null}
      open={showAddModalForDietCusines}
      onCancel={() => {
        setShowAddModalForDietCusines(false);
        setNewItem({ name: "", image: null });
      }}
      footer={null}
      centered
    >
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Typography.Title
          level={4}
          style={{ marginBottom: "20px", color: "#1C1C1C" }}
        >
          {currentCategory}
        </Typography.Title>

        <div
          style={{
            width: "100%",
            height: "250px",
            margin: "0 auto",
            overflow: "hidden",
            border: "1px solid #E0E0E0",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={newItem.image ? URL.createObjectURL(newItem.image) : DefaultImage}
            alt="Uploaded Preview"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              zIndex: 1000,
            }}
          />
        </div>
        <Input
          placeholder={`Enter ${currentCategory}`}
          value={newItem.name}
          onChange={(e) =>
            setNewItem((prev) => ({ ...prev, name: e.target.value }))
          }
          style={{
            marginTop: "20px",
            width: "80%",
            height: "40px",
            borderRadius: "4px",
            border: "1px solid #E0E0E0",
            padding: "0 10px",
          }}
        />
        <div style={{ marginTop: "20px" }}>
          <Upload
            name="image"
            listType="picture"
            showUploadList={false}
            accept="image/*"
            beforeUpload={(file) => {
              const isImage = file.type.startsWith("image/");
              const validExtensions = /\.(jpg|jpeg|png|gif)$/i;

              if (!isImage || !validExtensions.test(file.name)) {
                message.error("Only image files are allowed!");
                return Upload.LIST_IGNORE;
              }

              setNewItem((prev) => ({
                ...prev,
                image: file,
              }));
              return false;
            }}
          >
            <Button
              style={{
                backgroundColor: "#FF6B35",
                color: "#fff",
                border: "none",
                marginRight: "10px",
                borderRadius: "4px",
              }}
            >
              Upload
            </Button>
          </Upload>

          <Button
            type="primary"
            style={{
              backgroundColor: "#FF6B35",
              border: "none",
              borderRadius: "4px",
            }}
            onClick={handleUploadAndSave}
            disabled={!newItem.name || !newItem.image || isLoading}
          >
            {isLoading ? "Adding..." : "Add"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddDietCusiniesModal;
